
const digest = '91ba3602d07a43f903c58a728f7cd278d4d2d74e32cb16940e800d76ff031a0b';
const classes = {"infoText":"_infoText_233m3_1"};
const css = `._infoText_233m3_1 {
  font-size: 14px;
  font-weight: 500;
  padding-bottom: 15px;
  border-bottom: 1px solid #eaedf4;
  margin-bottom: 15px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  